import { extractProviderFromModelId } from './modelResolver';

// Logo mapping utility for AI models
// Uses modelResolver for robust provider detection
export const getModelLogo = (modelId: string, modelName?: string): string | null => {
  // First try to extract provider from modelResolver (most reliable)
  const provider = extractProviderFromModelId(modelId);

  // Provider-based logo mapping (primary method)
  const providerLogos: Record<string, string> = {
    'openai': '/logos/OpenAI-white-logo.png',
    'anthropic': '/logos/Claude-logo.png',
    'google': '/logos/Google-Gemini-logo.png',
    'deepseek': '/logos/deepseek-logo.png',
    'xai': '/logos/Grok-logo.png',
    'meta': '/logos/MetaLogo.png?v=2',
  };

  if (provider !== 'unknown' && providerLogos[provider]) {
    return providerLogos[provider];
  }

  // Fallback: string matching (for backwards compatibility)
  const id = modelId.toLowerCase();
  const name = modelName?.toLowerCase() || '';

  if (id.includes('claude') || name.includes('claude')) {
    return '/logos/Claude-logo.png';
  }

  if (id.includes('gpt') || id.includes('openai') || name.includes('gpt') || name.includes('openai')) {
    return '/logos/OpenAI-white-logo.png';
  }

  if (id.includes('gemini') || id.includes('google') || name.includes('gemini') || name.includes('google')) {
    return '/logos/Google-Gemini-logo.png';
  }

  if (id.includes('grok') || name.includes('grok')) {
    return '/logos/Grok-logo.png';
  }

  if (id.includes('meta') || id.includes('llama') || name.includes('meta') || name.includes('llama')) {
    return '/logos/MetaLogo.png?v=2';
  }

  if (id.includes('deepseek') || name.includes('deepseek')) {
    return '/logos/deepseek-logo.png';
  }

  if (id.includes('mistral') || name.includes('mistral')) {
    return '/logos/Mistral-boxed-rainbow-logo.png';
  }

  // Default fallback
  return null;
};

export const ModelLogo: React.FC<{
  modelId: string;
  modelName?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}> = ({ modelId, modelName, size = 'md', className = '' }) => {
  const logoSrc = getModelLogo(modelId, modelName);

  if (!logoSrc) {
    return null;
  }

  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  return (
    <img
      src={logoSrc}
      alt={`${modelName || modelId} logo`}
      className={`${sizeClasses[size]} object-contain flex-shrink-0 ${className}`}
      onError={(e) => {
        // Hide image if it fails to load
        e.currentTarget.style.display = 'none';
      }}
    />
  );
};